
const close = $('.js-notice-close');
const panel = $('.js-notice-panel');

close.on('click', function() {
  panel.hide();
});
